const DEFAULT_COOLDOWN_MS = 300;
let openCount = 0;
let fastPathUntil = 0;
export function resetPreviewTimingForTests() {
  openCount = 0;
  fastPathUntil = 0;
}
export function notePreviewOpened() {
  openCount += 1;
}
export function notePreviewClosed(now = Date.now(), cooldownMs = DEFAULT_COOLDOWN_MS) {
  openCount = Math.max(0, openCount - 1);
  if (openCount === 0) {
    fastPathUntil = now + cooldownMs;
  }
}
export function resolvePreviewOpenDelay(requestedDelay, now = Date.now()) {
  if (openCount > 0) {
    return 0;
  }
  if (now < fastPathUntil) {
    return 0;
  }
  return requestedDelay;
}